import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Grid, IconButton } from '@mui/material';
import { API } from '../utils/Api';
import { ToggleOnOutlined, ToggleOffOutlined } from '@mui/icons-material';

const AddonRawMaterial = () => {
  const token = localStorage.getItem('token');
  const outletData = JSON.parse(localStorage.getItem('outletData') || '{}');
  const outletId = outletData?._id;
  const [loading, setLoading] = useState(false);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [toggledStates, setToggledStates] = useState({});

  useEffect(() => {
    fetchRawMaterials();
  }, []);

  const fetchRawMaterials = async () => {
    try {
      const response = await axios.get(`${API.BASE_URL}raw-material/size-raw-materials`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data?.status) {
        const rawMaterialsData = response.data.data.rawMaterialsSizeAddons;
        setRawMaterials(rawMaterialsData);

        // Initialize toggle state based on excludedOutlets
        const initialToggles = {};
        rawMaterialsData.forEach((item) => {
          const addonValueId = item?.addonItem?._id;
          const excludedOutlets = item?.addonItem?.excludedOutlets || [];
          const isExcluded = excludedOutlets.includes(outletId);
          initialToggles[addonValueId] = isExcluded; // true means inactive
        });
        setToggledStates(initialToggles);
      } else {
        console.error('Failed to fetch raw materials');
      }
    } catch (err) {
      console.error('API error:', err);
    }
  };

  const handleToggle = async (addonId, addonValueId, productIds, currentState) => {
    const type = currentState ? 'INCLUDE' : 'EXCLUDE';

    try {
      await axios.post(`${API.BASE_URL}raw-material/include-exclude-size-addon`, {
        addonData: [
          {
            addonId,
            addonValueId,
            products: productIds,
            type,
          },
        ],
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setToggledStates((prev) => ({ ...prev, [addonValueId]: !currentState }));
    } catch (err) {
      console.error('Failed to toggle raw material', err);
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h5" gutterBottom>
        Raw Materials of Addon Sizes
      </Typography>

      <Grid container spacing={2}>
        {rawMaterials.map((item, index) => {
          const addonId = item.addon?._id;
          const addonValueId = item.addonItem?._id;
          const productIds = item.products?.map((p) => p._id) || [];
          const isToggled = toggledStates[addonValueId] || false;

          return (
            <Grid key={index} item xs={12}>
              <Box
                sx={{
                  border: '1px solid #ccc',
                  borderRadius: 2,
                  padding: 2,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Box>
                  <Typography variant="h6">{item.rawMaterial?.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Size: {item.addonItem?.value}
                  </Typography>
                </Box>

                <Box sx={{ textAlign: 'center' }}>
                  <IconButton
                    onClick={() =>
                      handleToggle(addonId, addonValueId, productIds, isToggled)
                    }
                  >
                    {isToggled ? (
                      <ToggleOffOutlined sx={{ fontSize: 28, color: 'red' }} />
                    ) : (
                      <ToggleOnOutlined sx={{ fontSize: 28, color: 'green' }} />
                    )}
                  </IconButton>
                  <Typography sx={{ fontSize: 13 }}>
                    {isToggled ? 'Inactives' : 'Active'}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default AddonRawMaterial;
